import type { CSSProperties } from 'react'
import { C } from '../theme'
import { Reveal } from './Reveal'
import { useContent } from '../content/ContentContext'
import { mediaUrl } from '../content/derive'

const eyebrowStyle: CSSProperties = {
  fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase',
  color: C.red, marginBottom: 22,
}

const bodyStyle: CSSProperties = {
  fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 30, lineHeight: 1.45,
  margin: 0, color: C.ink, letterSpacing: '-.01em', textWrap: 'pretty',
}

const rule = (margin: string): CSSProperties => ({
  width: 54, height: 3, background: C.gold, margin, borderRadius: 2,
})

export function Mission() {
  const { home, settings } = useContent()
  const mission = home.mission ?? {}
  const vision = home.vision ?? {}
  const emblemUrl = mediaUrl(settings.branding?.emblem)

  if (!mission.body && !vision.body) return null

  return (
    <section className="sec" style={{ padding: '104px 40px', background: C.sand, position: 'relative' }}>
      <Reveal style={{ maxWidth: 920, margin: '0 auto', textAlign: 'center' }}>
        {emblemUrl && (
          <img src={emblemUrl} alt="" style={{ height: 64, width: 'auto', margin: '0 auto 26px', opacity: 0.95, display: 'block' }} />
        )}
        {mission.body && (
          <>
            <div style={eyebrowStyle}>{mission.eyebrow}</div>
            <p style={bodyStyle}>{mission.body}</p>
          </>
        )}
        {mission.body && vision.body && <div style={rule('34px auto')} />}
        {vision.body && (
          <>
            <div style={eyebrowStyle}>{vision.eyebrow}</div>
            <p style={bodyStyle}>{vision.body}</p>
            <div style={rule('30px auto 0')} />
          </>
        )}
      </Reveal>
    </section>
  )
}
